export default {
  title: 'Lingua',
  save_changes: 'Salva modifiche',
};
